import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { AuthCard, api, takeFragmentToken } from '@jupi/ui'

const CLUB = 'Jukolan Pilotit ry'

// Where the confirmation email's link lands: /join/verify#token=... The
// applicant presses a button rather than the page verifying on load, so a
// mail provider's link scanner cannot verify an address for its owner.
export default function VerifyApplicationEmailPage() {
  const { t } = useTranslation()
  const [token] = useState(takeFragmentToken)
  const [state, setState] = useState<'ready' | 'busy' | 'done' | 'invalid'>(token ? 'ready' : 'invalid')

  const verify = async () => {
    setState('busy')
    try {
      await api.post('/api/public/membership/verify-email', { token })
      setState('done')
    } catch {
      setState('invalid')
    }
  }

  return (
    <AuthCard title={t('join.verify.title')} subtitle={CLUB}>
      <Stack spacing={2}>
        {state === 'invalid' ? <Alert severity="warning">{t('join.verify.invalid')}</Alert> : null}
        {state === 'done' ? <Alert severity="success">{t('join.verify.done')}</Alert> : null}
        {state === 'ready' || state === 'busy' ? (
          <>
            {t('join.verify.intro', { club: CLUB })}
            <Button variant="contained" size="large" fullWidth disabled={state === 'busy'} onClick={verify} autoFocus>
              {state === 'busy' ? t('join.verify.checking') : t('join.verify.button')}
            </Button>
          </>
        ) : null}
      </Stack>
    </AuthCard>
  )
}
